import React from 'react';
import {
    Area,
    AreaChart,
    Bar,
    BarChart,
    Line,
    LineChart,
    ResponsiveContainer,
} from 'recharts';
import {
    data,
    data1,
    data2,
} from './data';
import ChartCard from 'components/dashboard/Common/ChartCard';
import ContainerHeader from 'components/ContainerHeader/index';
import SalesStatistic from 'components/dashboard/eCommerce/SalesStatistic';
import IntlMessages from 'util/IntlMessages';

class AgileDashboard extends React.Component {

    onOptionMenuToggle = () => {
        this.setState({menuState: !this.state.menuState});
    };
    handleRequestClose = () => {
        this.setState({menuState: false});
    };

    constructor() {
        super();
        this.state = {
            menuState: false,
        };
    }

    render() {
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <ContainerHeader match={this.props.match} title={<IntlMessages id="sidebar.superuser.dashboard"/>}/>

                <div className="row">
                    <div className="col-lg-3 col-sm-6 col-12">
                        <ChartCard styleName="bg-secondary text-white">
                            <div className="chart-title">
                                <h2>1379</h2>
                                <p><IntlMessages id="dashboard.onlineSignups"/></p>
                            </div>

                            <ResponsiveContainer width="100%" height={110}>
                                <BarChart data={data}>
                                    <Bar dataKey="pv" fill="white"/>
                                    <Bar dataKey="uv" fill="white"/>
                                </BarChart>
                            </ResponsiveContainer>
                        </ChartCard>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                        <ChartCard styleName="bg-primary text-white">
                            <div className="chart-title">
                                <h2>$7,890</h2>
                                <p><IntlMessages id="dashboard.lastMonthSale"/></p>
                            </div>

                            <ResponsiveContainer width="100%" height={110}>
                                <AreaChart data={data1} margin={{top: 0, right: 0, left: 0, bottom: 0}}>
                                    <Area type="monotone" dataKey="pv" stroke="rgba(255,255,255,0.5)"
                                          activeDot={{r: 8}}
                                          fillOpacity={.5}
                                          fill="white"/>
                                </AreaChart>
                            </ResponsiveContainer>
                        </ChartCard>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                        <ChartCard styleName="bg-teal lighten-1 text-white">
                            <div className="chart-title">
                                <h2>236</h2>
                                <p><IntlMessages id="dashboard.newVisits"/></p>
                            </div>


                            <ResponsiveContainer width="100%" height={110}>
                                <LineChart data={data2}>
                                    <Line type="monotone" dataKey="uv" stroke="#ffffff" activeDot={{r: 8}}/>
                                    <Line type="monotone" dataKey="pv" stroke="#ffffff"/>
                                    <Line type="monotone" dataKey="amt" stroke="#ffffff"/>
                                </LineChart>
                            </ResponsiveContainer>

                        </ChartCard>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                        <ChartCard styleName="bg-blue text-white">
                            <div className="chart-title">
                                <h2>$87,345</h2>
                                <p><IntlMessages id="dashboard.totalRevenue"/></p>
                            </div>

                            <ResponsiveContainer width="100%" height={110}>
                                <LineChart data={data1}>
                                    <Line dataKey="uv" stroke="#ffffff" activeDot={{r: 8}}/>
                                </LineChart>
                            </ResponsiveContainer>
                        </ChartCard>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <SalesStatistic/>
                    </div>
                </div>
            </div>
        );
    }
}

export default AgileDashboard;


// WEBPACK FOOTER //
// ./components/Agile/Dashboard/index.js